var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoAgent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#A5A5A5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6220_33225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95991 7.77C7.55991 7.6 7.38991 7.105 7.62991 6.745C8.11491 6.025 8.92491 5.5 9.99491 5.5C11.1699 5.5 11.9749 6.035 12.3849 6.705C12.7349 7.28 12.9399 8.355 12.3999 9.155C11.7999 10.04 11.2249 10.31 10.9149 10.88C10.8399 11.015 10.7949 11.125 10.7649 11.35C10.7199 11.715 10.4199 12 10.0499 12C9.61491 12 9.25991 11.625 9.30991 11.19C9.33991 10.935 9.39991 10.67 9.53991 10.42C9.92491 9.725 10.6649 9.315 11.0949 8.7C11.5499 8.055 11.2949 6.85 10.0049 6.85C9.41991 6.85 9.03991 7.155 8.80491 7.52C8.62991 7.805 8.26491 7.895 7.95991 7.77ZM10.9999 14C10.9999 14.55 10.5499 15 9.99991 15C9.44991 15 8.99991 14.55 8.99991 14C8.99991 13.45 9.44991 13 9.99991 13C10.5499 13 10.9999 13.45 10.9999 14Z",
    fill: "#A5A5A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6220_33225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoAgent);
export default __webpack_public_path__ + "static/media/ic_no-agent.f32eee7f645ef0bf393c58f1d3ecea6a.svg";
export { ForwardRef as ReactComponent };